import React from 'react';
export default function UnsupportedNodeAttribute(props) {
  return /*#__PURE__*/React.createElement("span", props.dataAttributes, props.children);
}